<template>
  <div class="exhibition-main-container">
    <div class="product-grid">
      <div
        v-for="item in currentPageData"
        :key="item.id"
        class="product-item"
        @click="goToDetail(item.id)"
      >
        <div class="product-card">
          <div class="image-container">
            <img :src="item.coverImage" :alt="item.title">
            <div class="blue-line image-line"></div>
          </div>
          <div class="title-container">
            <h4 class="item-title">{{ item.title }}</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalItems"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import exhibitionData from '@/data/exhibitionData'

export default {
  name: 'Exhibition2',
  data() {
    return {
      currentPage: 1,
      pageSize: 6, // 六宫格布局，每页6个产品
      productData: exhibitionData.filter(item => item.category === '智能家居')
    }
  },
  computed: {
    totalItems() {
      return this.productData.length
    },
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.productData.slice(start, end)
    }
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page
    },
    goToDetail(productId) {
      // 跳转到产品详情页面
      this.$router.push(`/exhibition/detail/${productId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.exhibition-main-container {
  margin: 4% auto 8%;

  .product-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    width: 94%;
    max-width: 1280px;
    margin: auto;
  }

  .product-item {
    cursor: pointer;
    padding: 0 20px; // 增加左右边距，让卡片容器变小
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    .product-card {
      // 移除背景、边框、阴影等样式，只保留过渡动画
      transition: all 0.3s ease;
    }

    &:hover {
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2); // 悬停时阴影加深
      transform: translateY(-2px); // 轻微上移效果

      .product-card {
        .image-container {
          img {
            transform: scale(1.15);
          }

          .image-line {
            width: 100%;
          }
        }

      }
    }

    .image-container {
      position: relative;
      overflow: hidden;
      max-height: 480px; // 增大最大统一高度
      border-bottom: 1px solid #e5e5e5; // 加粗灰色底部边框
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%; // 调小图片宽度
        height: auto; // 高度自适应
        max-height: 450px; // 调大图片最大高度，接近容器极限
        object-fit: contain; // 完整展示图片，保持宽高比
        object-position: center;
        transition: transform 0.4s ease;
      }

      .image-line {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px; // 加粗蓝色分割线
        background: #0555b6;
        width: 0;
        transition: width 0.6s ease;
        z-index: 2;
      }
    }

    .title-container {
      padding: 20px;

      .item-title {
        font-size: 16px;
        color: #333;
        margin: 0;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: color 0.3s ease;
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
}

@media (max-width: 768px) {
  .product-grid {
    grid-template-columns: repeat(1, 1fr) !important;
    padding: 20px;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
</style>